import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import { AMd } from "./aMd"

const query = graphql`
    query {
        pageText {
            link {
                registration
            }
        }
    }

`;

export const RegistrationMd = ({children}) => {
    const data = useStaticQuery(query);
    const link = data.pageText.link.registration;

    return <AMd href={link} children={children} />
}